import styled from 'styled-components';
import palette from '@telus-uds/palette-allium/build/web/palette';

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;

export const ExportButton = styled.button`
  color: ${palette.color.white};
  background-color: ${palette.color.greenAccessible};
`;
